/**
 * Block dependencies.
 */
import classnames from "classnames";
import "./editor.scss";
import "./style.scss";

import Settings from "./settings";
import Buttons from "./buttons";
/**
 * Block libraries
 */

const { __ } = wp.i18n;
const { Fragment } = wp.element;
const {
  InspectorControls,
  AlignmentToolbar,
  BlockControls,
  BlockAlignmentToolbar
} = wp.editor;
const { registerBlockType } = wp.blocks;

const SSB_ALIGNMENT_CONTROLS = [
  {
    icon: "editor-alignleft",
    title: __("Align Left"),
    align: "left"
  },
  {
    icon: "editor-aligncenter",
    title: __("Align Center"),
    align: "centered"
  },
  {
    icon: "editor-alignright",
    title: __("Align Right"),
    align: "right"
  }
];

export default registerBlockType("ssb/shortcode", {
  title: __("Simple Social Buttons"),
  description: __(
    "Simple Social Buttons adds an advanced set of social media sharing buttons to your  sites, such as: Facebook, WhatsApp, Viber, Twitter, Reddit, LinkedIn and Pinterest."
  ),
  category: "common",
  icon: "networking",
  keywords: [__("Social Share"), __("Button"), __("ssb")],
  attributes: {
    theme: {
      type: "string",
      default: "simple-icons"
    },
    counter: {
      type: "boolean",
      default: false
    },
    showTotalCount: {
      type: "boolean",
      default: false
    },
    align: {
      type: "string",
      default: ""
    },
    order: {
      type: "string",
      default: "fbshare,twitter,linkedin"
    },
    likeButtonSize: {
      type: "string",
      default: "small"
    },
    alignment: {
      type: "string",
      default: "left"
    }
  },
  getEditWrapperProps({ align }) {
    if ("center" === align || "wide" === align || "full" === align) {
      return { "data-align": align };
    }
  },
  supports: {
    // Turn off ability to edit HTML of block content
    html: false,
    // Turn off reusable block feature
    reusable: false
  },
  edit: props => {
    const {
      attributes: { alignment, align, theme, counter },
      className,
      setAttributes
    } = props;
    const mainClasses = classnames(
      className,
      "simplesocialbuttons",
      "simplesocialbuttons_inline",
      { [`simplesocial-${theme}`]: theme },
      { [`align${align}`]: align },
      { "ssb_counter-activate": counter },
      { [`simplesocialbuttons-align-${alignment}`]: alignment }
    );
    return (
      <Fragment>
        <BlockControls>
          <BlockAlignmentToolbar
            value={align}
            onChange={align => setAttributes({ align })}
            controls={["center", "wide", "full"]}
          />
          <AlignmentToolbar
            value={alignment}
            onChange={alignment => setAttributes({ alignment })}
            alignmentControls={SSB_ALIGNMENT_CONTROLS}
          />
        </BlockControls>
        <InspectorControls>
          <Settings {...props} />
        </InspectorControls>
        <div className={mainClasses}>
          <Buttons {...props} />
        </div>
      </Fragment>
    );
  },
  save: props => {
    return null;
  }
});



// WEBPACK FOOTER //
// blocks/shortcode/index.js